/**
 * Generated by orval v8.18.0 🍺
 * Do not edit manually.
 * LiftAI API
 * LiftAI elevator/lift asset-management REST API.
 * OpenAPI spec version: 1.0.0 (v1)
 */
import type {
  CfiContractChunk,
  CfiReport,
  Contract,
  ContractEndRequest,
  ContractReviewRule,
  ContractReviewRuleRequest,
  ContractWrite,
  ContractWriteRequest,
  ContractsListParams,
  PaginatedContractList,
  PatchedContractWriteRequest
} from '../../model';

import { customFetch } from '../../../liftApiMutator';

export type contractsListResponse200 = {
  data: PaginatedContractList
  status: 200
}

export type contractsListResponseSuccess = (contractsListResponse200) & {
  headers: Headers;
};
;

export type contractsListResponse = (contractsListResponseSuccess)

export const getContractsListUrl = (params?: ContractsListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["portfolio","region","service_provider"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : String(v));
      });
      return;
    }

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/contracts/?${stringifiedParams}` : `/api/v1/contracts/`
}

/**
 * Full API CRUD access to Contract entities.
 */
export const contractsList = async (params?: ContractsListParams, options?: RequestInit): Promise<contractsListResponse> => {

  return customFetch<contractsListResponse>(getContractsListUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}


export type contractsCreateResponse201 = {
  data: Contract
  status: 201
}

export type contractsCreateResponseSuccess = (contractsCreateResponse201) & {
  headers: Headers;
};
;

export type contractsCreateResponse = (contractsCreateResponseSuccess)

export const getContractsCreateUrl = () => {




  return `/api/v1/contracts/`
}

/**
 * Create a new contract and return the full contract data.
 *
 * The default schema would type the 201 body as ``ContractWrite`` (the
 * request serializer); declare the read serializer so the SDK gets the
 * full ``Contract`` this actually returns.
 */
export const contractsCreate = async (contractWriteRequest: ContractWriteRequest, options?: RequestInit): Promise<contractsCreateResponse> => {

  return customFetch<contractsCreateResponse>(getContractsCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(contractWriteRequest)
  }
);}


export type contractsCfiReportsListResponse200 = {
  data: CfiReport[]
  status: 200
}

export type contractsCfiReportsListResponseSuccess = (contractsCfiReportsListResponse200) & {
  headers: Headers;
};
;

export type contractsCfiReportsListResponse = (contractsCfiReportsListResponseSuccess)

export const getContractsCfiReportsListUrl = (contractPk: string,) => {




  return `/api/v1/contracts/${contractPk}/cfi/reports/`
}

/**
 * Read CFI reports for a contract; trigger new runs via the `run` action.
 *
 * URL pattern:
 *   /api/v1/contracts/{contract_pk}/cfi/reports/
 *   /api/v1/contracts/{contract_pk}/cfi/reports/{pk}/
 *   /api/v1/contracts/{contract_pk}/cfi/run/ (POST)
 */
export const contractsCfiReportsList = async (contractPk: string, options?: RequestInit): Promise<contractsCfiReportsListResponse> => {

  return customFetch<contractsCfiReportsListResponse>(getContractsCfiReportsListUrl(contractPk),
  {
    ...options,
    method: 'GET'


  }
);}


export type contractsCfiReportsRetrieveResponse200 = {
  data: CfiReport
  status: 200
}

export type contractsCfiReportsRetrieveResponseSuccess = (contractsCfiReportsRetrieveResponse200) & {
  headers: Headers;
};
;

export type contractsCfiReportsRetrieveResponse = (contractsCfiReportsRetrieveResponseSuccess)

export const getContractsCfiReportsRetrieveUrl = (contractPk: string,
    id: string,) => {




  return `/api/v1/contracts/${contractPk}/cfi/reports/${id}/`
}

/**
 * Read CFI reports for a contract; trigger new runs via the `run` action.
 *
 * URL pattern:
 *   /api/v1/contracts/{contract_pk}/cfi/reports/
 *   /api/v1/contracts/{contract_pk}/cfi/reports/{pk}/
 *   /api/v1/contracts/{contract_pk}/cfi/run/ (POST)
 */
export const contractsCfiReportsRetrieve = async (contractPk: string,
    id: string, options?: RequestInit): Promise<contractsCfiReportsRetrieveResponse> => {

  return customFetch<contractsCfiReportsRetrieveResponse>(getContractsCfiReportsRetrieveUrl(contractPk,id),
  {
    ...options,
    method: 'GET'


  }
);}


export type contractsCfiRunCreateResponse200 = {
  data: CfiReport
  status: 200
}

export type contractsCfiRunCreateResponseSuccess = (contractsCfiRunCreateResponse200) & {
  headers: Headers;
};
;

export type contractsCfiRunCreateResponse = (contractsCfiRunCreateResponseSuccess)

export const getContractsCfiRunCreateUrl = (contractPk: string,) => {




  return `/api/v1/contracts/${contractPk}/cfi/run/`
}

/**
 * Read CFI reports for a contract; trigger new runs via the `run` action.
 *
 * URL pattern:
 *   /api/v1/contracts/{contract_pk}/cfi/reports/
 *   /api/v1/contracts/{contract_pk}/cfi/reports/{pk}/
 *   /api/v1/contracts/{contract_pk}/cfi/run/ (POST)
 */
export const contractsCfiRunCreate = async (contractPk: string, options?: RequestInit): Promise<contractsCfiRunCreateResponse> => {

  return customFetch<contractsCfiRunCreateResponse>(getContractsCfiRunCreateUrl(contractPk),
  {
    ...options,
    method: 'POST'


  }
);}


export type contractsChunksListResponse200 = {
  data: CfiContractChunk[]
  status: 200
}

export type contractsChunksListResponseSuccess = (contractsChunksListResponse200) & {
  headers: Headers;
};
;

export type contractsChunksListResponse = (contractsChunksListResponseSuccess)

export const getContractsChunksListUrl = (contractPk: string,) => {




  return `/api/v1/contracts/${contractPk}/chunks/`
}

/**
 * GET /api/v1/contracts/{contract_pk}/chunks/?ids=<uuid>,<uuid>
 *
 * Returns the verbatim chunk text + page number for the requested ids,
 * filtered to chunks that actually belong to this contract. Powers the FE
 * evidence panel popover.
 */
export const contractsChunksList = async (contractPk: string, options?: RequestInit): Promise<contractsChunksListResponse> => {

  return customFetch<contractsChunksListResponse>(getContractsChunksListUrl(contractPk),
  {
    ...options,
    method: 'GET'


  }
);}


export type contractsRetrieveResponse200 = {
  data: Contract
  status: 200
}

export type contractsRetrieveResponseSuccess = (contractsRetrieveResponse200) & {
  headers: Headers;
};
;

export type contractsRetrieveResponse = (contractsRetrieveResponseSuccess)

export const getContractsRetrieveUrl = (id: string,) => {




  return `/api/v1/contracts/${id}/`
}

/**
 * Full API CRUD access to Contract entities.
 */
export const contractsRetrieve = async (id: string, options?: RequestInit): Promise<contractsRetrieveResponse> => {

  return customFetch<contractsRetrieveResponse>(getContractsRetrieveUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}


export type contractsUpdateResponse200 = {
  data: ContractWrite
  status: 200
}

export type contractsUpdateResponseSuccess = (contractsUpdateResponse200) & {
  headers: Headers;
};
;

export type contractsUpdateResponse = (contractsUpdateResponseSuccess)

export const getContractsUpdateUrl = (id: string,) => {




  return `/api/v1/contracts/${id}/`
}

/**
 * Full API CRUD access to Contract entities.
 */
export const contractsUpdate = async (id: string,
    contractWriteRequest: ContractWriteRequest, options?: RequestInit): Promise<contractsUpdateResponse> => {

  return customFetch<contractsUpdateResponse>(getContractsUpdateUrl(id),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(contractWriteRequest)
  }
);}


export type contractsPartialUpdateResponse200 = {
  data: ContractWrite
  status: 200
}

export type contractsPartialUpdateResponseSuccess = (contractsPartialUpdateResponse200) & {
  headers: Headers;
};
;

export type contractsPartialUpdateResponse = (contractsPartialUpdateResponseSuccess)

export const getContractsPartialUpdateUrl = (id: string,) => {




  return `/api/v1/contracts/${id}/`
}

/**
 * Full API CRUD access to Contract entities.
 */
export const contractsPartialUpdate = async (id: string,
    patchedContractWriteRequest?: PatchedContractWriteRequest, options?: RequestInit): Promise<contractsPartialUpdateResponse> => {

  return customFetch<contractsPartialUpdateResponse>(getContractsPartialUpdateUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(patchedContractWriteRequest)
  }
);}


export type contractsDestroyResponse204 = {
  data: void
  status: 204
}

export type contractsDestroyResponseSuccess = (contractsDestroyResponse204) & {
  headers: Headers;
};
;

export type contractsDestroyResponse = (contractsDestroyResponseSuccess)

export const getContractsDestroyUrl = (id: string,) => {




  return `/api/v1/contracts/${id}/`
}

/**
 * Full API CRUD access to Contract entities.
 */
export const contractsDestroy = async (id: string, options?: RequestInit): Promise<contractsDestroyResponse> => {

  return customFetch<contractsDestroyResponse>(getContractsDestroyUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}


export type contractsEndCreateResponse204 = {
  data: void
  status: 204
}

export type contractsEndCreateResponseSuccess = (contractsEndCreateResponse204) & {
  headers: Headers;
};
;

export type contractsEndCreateResponse = (contractsEndCreateResponseSuccess)

export const getContractsEndCreateUrl = (id: string,) => {




  return `/api/v1/contracts/${id}/end/`
}

/**
 * End a contract
 */
export const contractsEndCreate = async (id: string,
    contractEndRequest: ContractEndRequest, options?: RequestInit): Promise<contractsEndCreateResponse> => {

  return customFetch<contractsEndCreateResponse>(getContractsEndCreateUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(contractEndRequest)
  }
);}


export type contractsReviewRulesCreateResponse201 = {
  data: ContractReviewRule
  status: 201
}

export type contractsReviewRulesCreateResponseSuccess = (contractsReviewRulesCreateResponse201) & {
  headers: Headers;
};
;

export type contractsReviewRulesCreateResponse = (contractsReviewRulesCreateResponseSuccess)

export const getContractsReviewRulesCreateUrl = (id: string,) => {




  return `/api/v1/contracts/${id}/review-rules/`
}

/**
 * Append a single review rule to a contract.
 *
 * Atomic single-rule create, used by the AI-vs-consultant rule-suggestion
 * flow. Unlike the full contract PATCH (which replaces the whole
 * review_rules array), this only adds — it never updates or deletes
 * existing rules.
 */
export const contractsReviewRulesCreate = async (id: string,
    contractReviewRuleRequest: ContractReviewRuleRequest, options?: RequestInit): Promise<contractsReviewRulesCreateResponse> => {

  return customFetch<contractsReviewRulesCreateResponse>(getContractsReviewRulesCreateUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(contractReviewRuleRequest)
  }
);}


